import { SVGProps } from "react"

const Play2Icon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 3.08105C5.99994 3.06115 6.0054 3.03678 6.02246 3.00977C6.04009 2.98195 6.07135 2.94974 6.12012 2.9248L6.13086 2.91895L6.14258 2.91309C6.18735 2.88888 6.24371 2.87396 6.30469 2.875C6.36578 2.87606 6.42112 2.89279 6.46387 2.91797L6.4707 2.92188L6.47754 2.92676L18.1641 9.56641L18.168 9.56934C18.2148 9.59563 18.2453 9.62767 18.2627 9.65625C18.2797 9.68426 18.2861 9.71058 18.2861 9.73242C18.2861 9.7542 18.2796 9.77974 18.2627 9.80762C18.2453 9.83626 18.2149 9.86913 18.168 9.89551L18.1641 9.89746L6.47754 16.5381L6.46387 16.5459C6.42111 16.5711 6.36585 16.5878 6.30469 16.5889C6.24363 16.5899 6.18738 16.575 6.14258 16.5508L6.13086 16.5449L6.12012 16.5391C6.07155 16.5142 6.04009 16.4828 6.02246 16.4551C6.00528 16.428 5.99994 16.4028 6 16.3828V3.08105Z"
        stroke={"currentColor"}
        stroke-width="2"
      />
    </svg>
  )
}
export default Play2Icon
